module.exports = __webpack_public_path__ + "img/backyard-cross-angle.5b56602e.webp";